import type { HTMLAttributes } from 'react';

export type StatusTone = 'info' | 'success' | 'danger';

export type StatusBadgeProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: StatusTone;
};

export const StatusBadge = ({ children, className, tone = 'info', ...props }: StatusBadgeProps) => (
  <span
    role='status'
    className={['hotam-status-badge', `hotam-status-badge--${tone}`, className]
      .filter(Boolean)
      .join(' ')}
    {...props}
  >
    <span
      aria-hidden='true'
      className='hotam-status-badge__dot'
    />
    {children}
  </span>
);
